import ResourceManager from "./ResourceManager.js";

export * from "./Actualites.js";
export * from "./Contact.js";
export * from "./Crous.js";
export * from "./CustomSocketData.js";
export * from "./CrousData.js";
export * from "./Menu.js";
export * from "./Opening.js";
export * from "./Position.js";
export * from "./Residence.js";
export * from "./Restaurant.js";
export * from "./Utils.js";
export * from "./CustomHolidays.js";
export { ResourceManager };
